import React, { useEffect, useRef } from "react";

import style from "./styles.module.scss";

import "@material/web/checkbox/checkbox.js";

export interface MaterialCheckboxElement extends HTMLElement {
  checked: boolean;
  disabled: boolean;
  indeterminate: boolean;
}

interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
  id: string;
  label: string;
  labelPosition?: "start" | "end";
  onChange: (checked: boolean) => void;
}

export default function Checkbox({
  checked,
  disabled = false,
  id,
  label,
  labelPosition = "end",
  onChange,
}: CheckboxProps) {
  const ref = useRef<MaterialCheckboxElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    element.checked = checked;

    const handleChange = () => onChange(element.checked);

    element.addEventListener("change", handleChange);

    return () => element.removeEventListener("change", handleChange);
  }, [checked, onChange]);

  return (
    <div className={`${style.field} ${labelPosition === "start" ? style.labelStart : ""}`}>
      {React.createElement("md-checkbox", {
        "aria-label": label,
        class: style.checkbox,
        disabled: disabled ? "" : undefined,
        id,
        ref,
        "touch-target": "wrapper",
      })}
      <label className={`pgm-label-large ${style.label}`} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
